// extracted by mini-css-extract-plugin
export default {"container":"TradeFairInformation_container__gWu9X","action":"TradeFairInformation_action__cxjED","actionText":"TradeFairInformation_actionText__QYgQv"};